import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop completed with undelivered notifications"
// warning that some Radix/cmdk combinations emit — it has no functional impact but
// otherwise triggers the CRA dev error overlay.
const _roMsg = 'ResizeObserver loop';
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes(_roMsg)) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
  }
});

// Register PWA service worker + detect updates for the "Update available" banner.
if ('serviceWorker' in navigator) {
  let refreshing = false;
  // When the new SW takes control (after SKIP_WAITING), reload once into it.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  const notifyWaiting = (worker) => {
    if (!worker) return;
    window.__swWaiting = worker;
    window.dispatchEvent(new CustomEvent('sw-update-available'));
  };

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((reg) => {
      // Already a waiting worker (update downloaded on a prior visit).
      if (reg.waiting && navigator.serviceWorker.controller) notifyWaiting(reg.waiting);
      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener('statechange', () => {
          // Installed + an existing controller => this is an update, not first install.
          if (nw.state === 'installed' && navigator.serviceWorker.controller) notifyWaiting(nw);
        });
      });
      // Periodically poll so long-lived sessions notice new deploys.
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    }).catch(() => {});
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
